import { render, staticRenderFns } from "./AddonInformationSummary.vue?vue&type=template&id=52c393dc&scoped=true"
import script from "./AddonInformationSummary.vue?vue&type=script&lang=js"
export * from "./AddonInformationSummary.vue?vue&type=script&lang=js"
import style0 from "./AddonInformationSummary.vue?vue&type=style&index=0&id=52c393dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c393dc",
  null
  
)

export default component.exports